import { render, staticRenderFns } from "./serviceIntelligencePost.vue?vue&type=template&id=8b7367de&scoped=true&"
import script from "./serviceIntelligencePost.vue?vue&type=script&lang=js&"
export * from "./serviceIntelligencePost.vue?vue&type=script&lang=js&"
import style0 from "./serviceIntelligencePost.vue?vue&type=style&index=0&id=8b7367de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7367de",
  null
  
)

export default component.exports